import { Palette } from "lucide-react";
import type React from "react";
import type { DataFieldColor } from "schema/agent";
import { Field } from "./Field";

export interface ColorFieldProps {
  field: DataFieldColor;
  onChange: (value: string) => void;
}

export const ColorField: React.FC<ColorFieldProps> = ({ field, onChange }) => {
  return (
    <Field icon={Palette} label={field.label} visibleAt={field.visibleAt}>
      <div className="flex items-center gap-2">
        <input
          type="color"
          value={field.value}
          onChange={(e) => onChange(e.target.value)}
          className="w-8 md:w-6 h-8 md:h-6 p-0 border-0 rounded cursor-pointer"
        />
        <input
          type="text"
          value={field.value}
          onChange={(e) => onChange(e.target.value)}
          className="flex-1 h-8 md:h-6 bg-slate-900/50 text-slate-300 md:text-xs px-2 rounded focus:outline-none focus:ring-1 focus:ring-indigo-500 font-mono"
        />
      </div>
    </Field>
  );
};
